import axios from 'axios';
import { API_BASE_URL } from '../../config/api';
import { WorkflowTemplate } from '../../types';

export const workflowApi = {
  getTemplates: async (tenantId: string): Promise<WorkflowTemplate[]> => {
    const response = await axios.get(
      `${API_BASE_URL}/tenant/${tenantId}/workflow-templates`,
    );
    return response.data;
  },
};
